import React, { useState } from 'react';
// ✅ Importamos useNavigate de react-router-dom
import { useNavigate } from 'react-router-dom'; 
import { FaArrowLeft, FaUserTie, FaChevronDown, FaChevronUp, FaUser, FaBriefcase } from 'react-icons/fa';
import './TeamPage.css';

// 🛑 1. IMPORTACIONES DE FOTOS ELIMINADAS.
//    Las referencias de fotos ahora apuntan a la carpeta public/images/team.


// 🛑 DEFINICIÓN DE WHATSAPP GLOBAL PARA LA PÁGINA
const WHATSAPP_NUMBER = '14078738172';
const WHATSAPP_MESSAGE_TEAM = 'Hola, estoy visitando la página del equipo y me gustaría agendar una consulta con uno de sus expertos.';
const WHATSAPP_LINK_TEAM = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE_TEAM)}`;

const TEAM_MEMBERS = [
    // 🛑 MIEMBROS RESTANTES (7 en total)

    // ID 1: Yelene Fernández - RUTA CORREGIDA A .PNG
    // Archivo: yelene_fernandez_pro.png
    { id: 1, rol: "Yelene Fernández  / Abogada", titulo: "Especialista en Derecho Procesal Civil y Laboral", bio: `Egresada de la Universidad de Carabobo en 1997, con postgrados en Derecho Procesal Civil, Derecho Laboral y Derecho Penal. Su experiencia docente abarca desde 1999 hasta 2021... Actualmente, se desempeña como delegada de la Consultoría Jurídica de la Universidad Experimental para la Seguridad (UNES) en el núcleo Aragua.`, imgPlaceholder: FaUser, photoUrl: '/images/team/yelene Fernández .png' }, 
    
    // ID 2: Edgar Jordan - RUTA CORREGIDA A .PNG
    // Archivo: Edgar_Jordan.png (Nota: Se eliminó el _1 del nombre del archivo en la ruta, revisa tu carpeta)
    { id: 2, rol: "Edgar Jordan / Economista", titulo: "Especialista en Derecho Tributario y Doctor en Gerencia", bio: `Graduado de la Universidad de Carabobo, con especialización en Derecho Tributario, Doctor en Gerencia y múltiples maestrías... Más de 30 años de experiencia en la Contraloría General del Estado Aragua, donde fue Contralor del Municipio Zamora... Actualmente preside el Colegio de Economistas del Estado Aragua.`, imgPlaceholder: FaUser, photoUrl: '/images/team/Edgar Jordan.png' },
    
    // ID 3: Eumeli Velasquez - RUTA CORREGIDA A .PNG
    // Archivo: Eumeli_Velasquez.png
    { id: 3, rol: "Eumelia Velasquez / Abogada", titulo: "Especialista en Derecho Administrativo y Mercantil", bio: `Título en la Universidad Central de Venezuela y especializaciones en Derecho Administrativo, Mercantil y Procesal Civil... Ocupó cargos como secretaria en varios juzgados y juez titular en múltiples juzgados de primera instancia... Actualmente, se encuentra jubilada del Poder Judicial y ejerce libremente su profesión como abogada.`, imgPlaceholder: FaUser, photoUrl: '/images/team/Eumeli Velásquez.png' },
    
    // ID 4: Anibal Araque - RUTA CORREGIDA A .PNG
    // Archivo: Anibal_Araque.png (Nota: Se eliminó el _1 del nombre del archivo en la ruta, revisa tu carpeta)
    { id: 4, rol: "Anibal Araque / Economista", titulo: "Especialista en Proyectos de Inversión y Análisis de Riesgo", bio: `Graduado de la Universidad de Carabobo en 2009, con especialización en proyectos de inversión y análisis de riesgo... Cuenta con experiencia en asesorías financieras y crediticias para entes públicos y privados... Posee habilidades avanzadas en portugués e intermedias en inglés.`, imgPlaceholder: FaUser, photoUrl: '/images/team/Anibal Araque.png' },
    
    // ID 6: Francisco Rojas - RUTA CORREGIDA A .PNG
    // Archivo: Francisco_Rojas.png (Nota: Se eliminó el _1 del nombre del archivo en la ruta, revisa tu carpeta)
    { id: 6, rol: "Francisco Rojas / Abogado, Administrador", titulo: "Coronel (R) - Múltiples Doctorados y Ex-Rector Suplente UBA", bio: `Sólida formación académica que incluye múltiples doctorados en Ciencias Gerenciales, Ciencias de la Educación, Ciencias Jurídicas y Derecho Constitucional... Más de tres décadas en el Ministerio de la Defensa de Venezuela, donde se retiró como Coronel. Ha ocupado cargos académicos destacados.`, imgPlaceholder: FaUser, photoUrl: '/images/team/Francisco Rojas.png' },
    
    // ID 7: Karla Brown - RUTA CORREGIDA A .PNG
    // Archivo: Karla_Brown.png
    { id: 7, rol: "Karla Brown / Lic. Contaduría Pública", titulo: "Especialista en Actualización Tributaria y Gestión Contable", bio: `Graduada de la Universidad Bicentenaria de Aragua en 2006. Complementó su formación con un diplomado en Actualización Tributaria... Ha desempeñado roles como asesora financiera, jefe de personal, asesor de impuestos, gerente administrativo y contable, acumulando una sólida trayectoria en el ámbito de la contabilidad y las finanzas.`, imgPlaceholder: FaUser, photoUrl: '/images/team/Karla Brown.png' },
    
    // ID 9: Yurama Guzman - RUTA CORREGIDA A .PNG
    // Archivo: Yurama_Guzman.png
    { id: 9, rol: "Yaruma Guzman / Abogada", titulo: "Especialista en Gerencia Pública y Derecho Administrativo", bio: `Abogada egresada de la Universidad de Carabobo (1987). Posee especializaciones en Gerencia Pública y Derecho Administrativo. Sólida experiencia como Notario Titular en la Notaría Pública Tercera de Valencia y como Registrador Mercantil.`, imgPlaceholder: FaUser, photoUrl: '/images/team/Yurama Guzmán.png' },
];

const TeamMemberCard = ({ member }) => { 
    const [isExpanded, setIsExpanded] = useState(false);
    
    const shortBio = member.bio.includes('.') 
        ? member.bio.substring(0, member.bio.indexOf('.') + 1)
        : member.bio.substring(0, 100) + '...';

    const MemberPhotoComponent = () => {
        if (member.photoUrl) {
            // El componente img usa la ruta absoluta de la carpeta public/
            return <img src={member.photoUrl} alt={member.rol} className="member-photo-real" />;
        } else {
            const Icon = member.imgPlaceholder;
            return <Icon className="member-photo-placeholder" />;
        }
    };
    
    return (
        <div className="member-card">
            <div className="member-header">
                <MemberPhotoComponent />
                <div className="member-info-text">
                    <h3>{member.rol}</h3>
                    <h4>{member.titulo}</h4>
                </div>
                
                <button className="expand-button" onClick={() => setIsExpanded(!isExpanded)}>
                    {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                </button>
            </div>

            <div className={`member-bio ${isExpanded ? 'expanded' : 'collapsed'}`}>
                <p>{isExpanded ? member.bio : shortBio}</p>
                {!isExpanded && (
                    <span className="read-more-link" onClick={() => setIsExpanded(true)}>Ver más</span>
                )}
            </div>
        </div>
    );
};


// 🛑 TeamPage ya no recibe setActivePage
const TeamPage = () => {
    // ✅ Inicializamos useNavigate para manejar la navegación interna
    const navigate = useNavigate();
    
    // 🛑 Eliminamos la bandera isStandalone y la lógica de setActivePage

    return (
        <section id="team-page" className="team-container page-container">
            
            <div className="team-header">
                <FaUserTie className="team-icon" />
                <h1>Conoce a Nuestro Equipo</h1>
                <p>"Tu confianza es nuestra prioridad: Nos fundamos en más de 30 años de práctica legal ininterrumpida. Nuestro compromiso va más allá de la asesoría; se basa en el secreto profesional que rige la práctica del derecho en Venezuela. Aseguramos la confidencialidad absoluta de cada documento, dato y situación compartida. En Giovanni Scarvaci & Asociados, garantizamos que ningún tercero tendrá acceso a tu información legal o patrimonial sin tu consentimiento expreso o mandato de ley. Manejamos tu caso con la discreción y el rigor ético que exige la profesión."</p>
                <p>Nuestro equipo multidisciplinario combina experiencia legal, económica y financiera para brindarte soluciones integrales.</p>
            </div>
            
            <div className="team-members-grid">
                {TEAM_MEMBERS.map(member => (
                    // 🛑 Ya no pasamos setActivePage
                    <TeamMemberCard key={member.id} member={member} />
                ))}
            </div>
            
            <p className="team-contact-cta">
                <FaBriefcase style={{marginRight: '10px'}} /> 
                ¿Listo para trabajar con nuestros expertos? 
                <a 
                    className="cta-link" 
                    href={WHATSAPP_LINK_TEAM}
                    target="_blank" 
                    rel="noopener noreferrer"
                >
                    Agenda tu Consulta Aquí
                </a>
            </p>
            
            {/* ✅ CORRECCIÓN: Usamos navigate('/') para ir a la ruta de inicio */}
            <button className="back-button" onClick={() => navigate('/')}>
                <FaArrowLeft /> Volver al Inicio
            </button>
            
        </section>
    );
};

export default TeamPage;